<template>
  <v-container>
    <v-row>
      <v-col cols="12" lg="12">
        <v-sheet rounded="lg" :elevation="1">
          <v-data-table :items="orders" :headers="headers">
            <template v-slot:body="{ items }">
              <tbody class="text-left">
                <tr
                  v-for="item in items"
                  :key="item._id"
                  @click="
                    $route.params._id !== item._id
                      ? $router.push(`/validations/${item._id}`)
                      : null
                  "
                >
                  <td>{{ item.orderId }}{{ item.creatorTla }}</td>
                  <td>
                    {{ format(parseISO(item.createdAt), "dd.MM.yyyy") }}
                  </td>
                  <td>{{ item.currency }} {{ item.value.toFixed(2) }}</td>
                  <td>
                    {{ labels[item.status] }}
                  </td>
                </tr>
              </tbody>
            </template>
          </v-data-table>
        </v-sheet>
      </v-col>
      <v-col cols="12" lg="12">
        <v-sheet rounded="lg" :elevation="1">
          <stepper v-if="$route.fullPath !== '/validations'" />
        </v-sheet>
        <order-details v-if="$route.fullPath !== '/validations'" />
      </v-col>
    </v-row>
    <accept-dialog></accept-dialog>
    <reject-dialog></reject-dialog>
    <snackbar />
  </v-container>
</template>

<script>
import OrderDetails from "@/components/OrderDetails";
import Stepper from "@/components/Stepper";
import AcceptDialog from "@/components/AcceptDialog";
import RejectDialog from "@/components/RejectDialog";
import Snackbar from "@/components/Snackbar";
import { parseISO, format } from "date-fns";
import { mapState, mapActions } from "vuex";

export default {
  components: {
    Stepper,
    OrderDetails,
    AcceptDialog,
    RejectDialog,
    Snackbar,
  },
  async mounted() {
    try {
      this.loadValidations();
    } catch (error) {
      this.showError(error.message);
    }
  },
  computed: mapState({
    loading: (state) => state.validations.loading,
    orders: (state) => state.validations.all,
    total: (state) => state.validations.total,
    labels: (state) => state.orders.labels,
  }),
  methods: {
    ...mapActions("validations", ["loadValidations"]),
    ...mapActions("errors", ["showError"]),
  },
  data: () => ({
    page: 1,
    links: ["Mes commandes"],
    headers: [
      {
        text: "Numéro",
        value: "number",
        sortable: false,
      },
      {
        text: "Date du BC",
        value: "poDate",
      },
      {
        text: "Valeur",
        value: "value",
      },
      {
        text: "Statut de validation",
        value: "value",
      },
    ],
    format,
    parseISO,
  }),
};
</script>
